import { AxiosPromise } from "axios";
import { apiWrapper } from "../../axiosInstance";

export const validateSessionEndpoint = (): AxiosPromise<boolean> =>
    apiWrapper.instance!.get(`rest/session/validateSession`);
